module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_2"
    }
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("In loving memoriam to my great-grandmother, Vaotaua Laga’aia, born and raised in Vailoa, Palauli, Savai’i, and by marriage to my great-grandfather, of Afega, Samoa. Without her, we would not be this literate or as variegated and ambitious descendants vis-à-vis her grandsons. She was the embodiment of grace, love, and patience for these young souls who learned at her fingers and feet how to read the Bible and master their primers before they started primary school at Marist St. Joseph. Literacy was that important to her, and this carried forward to her seventh living generation today.")]), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("I hope to give her memory great honor. I ask this of Our Good Father. "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Ma le alofa tele ma le ‘ava tatau iai auā o lo’u tua’ā fa’apelepeleina!")])]), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_vm._v("– Elle, great-granddaughter.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4",
    attrs: {
      "id": "calibre_pb_1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75cf2a79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_001.vue
// module id = 66
// module chunks = 0